exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* table {\r\n  border-collapse: collapse;\r\n  margin: 50px auto;\r\n}\r\n\r\nth {\r\n  background: #3498db;\r\n  color: white;\r\n  font-weight: bold;\r\n}\r\n\r\ntd,\r\nth {\r\n  padding: 10px;\r\n  border: 1px solid #ccc;\r\n  text-align: left;\r\n  font-size: 18px;\r\n}\r\n\r\n.labels tr td {\r\n  background-color: #2cc16a;\r\n  font-weight: bold;\r\n  color: #fff;\r\n}\r\n\r\n.label tr td label {\r\n  display: block;\r\n}\r\n\r\n/* [data-toggle=\"toggle\"] {\r\n  display: none;\r\n} */ \r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/feedback-status/feedback-status.component.css
// module id = ../../../../../src/app/feedback-status/feedback-status.component.css
// module chunks = 0